import { useEffect, useState } from 'react';
import AuthAxios from '../../axios';
import { DeepLinkDefaultLink, getDeepLinkUri } from '../../utils/deepLinkUtils';
import { useNavigate } from 'react-router-dom';

export type SleepingJellyCouponModalType = {
  isSuccess: boolean;
  title: string;
  message: string;
  code: string;
};
type SetModalType = React.Dispatch<React.SetStateAction<boolean>>;
export default function SleepingJellyCouponModal({
  modalInfo,
  setModal,
}: {
  modalInfo: SleepingJellyCouponModalType;
  setModal: SetModalType;
}) {
  const navigate = useNavigate();
  const [deepLinkUri, setDeepLinkUri] = useState(DeepLinkDefaultLink);

  const onClickButton = () => {
    setModal(false);
    if (!modalInfo.isSuccess) {
      navigate('/jelly/coupon')
    }
  };
  useEffect(() => {
    getDeepLinkUri('jelly').then((url) => {
      setDeepLinkUri(url);
    });
  }, [modalInfo]);
  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#FFF',
        backgroundColor: '#00000091',
        zIndex: 9999
      }}
    >
      <div style={{ backgroundColor: '#191F28', borderRadius: 20 }}>
        <div
          style={{
            width: 260,
            padding: '36px 30px 20px 30px',
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
          }}
        >
          <div className="text-[16px] font-bold" style={{ whiteSpace: 'break-spaces' }}>
            {modalInfo.title}
          </div>
          <div className="text-[14px] text-[#D1D6DB]" style={{ whiteSpace: 'break-spaces' }}>
            {modalInfo.message}
          </div>
        </div>
        <div
          style={{
            padding: '10px 24px 20px 24px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <button onClick={onClickButton} style={{ borderRadius: 8, background: '#4F68FC', width: '100%', height: 56 }}>
            {modalInfo.isSuccess ? (
              <a className="flex justify-center items-center w-full h-full" href={deepLinkUri}>
                앱 열기
              </a>
            ) : (
              '닫기'
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
